
    import '@ve/components/dialogWrapper/common/activateVueFinalModal';
    import { DataLayerService, PromotionEvent } from "@/js/common/services/DataLayerService";

    import {
        computed,
        defineComponent, ref,
        SetupContext, toRefs, unref,
    } from 'vue';

    // eslint-disable-next-line import/no-cycle
    import useDialogWrapper from '@ve/components/dialogWrapper/common/use/useDialogWrapper';

    export default defineComponent({
        name: 'DialogWrapperDesktop',
        props: {
            dialogClass: {
                type: String,
                default: '',
            },
            overlayClass: {
                type: String,
                default: '',
            },
            hideOverlay: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
                default: '1000px',
            },
            preventClose: {
                type: Boolean,
                default: false,
            },
            closeOnEscape: {
                type: Boolean,
                default: true,
            },
            showCloseButton: {
                type: Boolean,
                default: true,
            },
            preventCloseWithCloseButton: {
                type: Boolean,
                default: false,
            },
            fullscreen: {
                type: Boolean,
                default: false,
            },
            canBeClosedByOthers: {
                type: Boolean,
                default: true,
            },
            promoData: {
                type: Object as PropType<PromotionEvent>,
                default: () => ({
                    title: '',
                    creative: '',
                    position: ''
                })
            }
        },
        emits: ['show', 'close'],
        setup(props, ctx: SetupContext) {
            const { dialogClass, overlayClass } = toRefs(props);
            const closedByButton = ref(false);

            const {
                open,
                close,
                onOpened,
                onClosed,
                isOpened,
                refVueFinalModal,
                refVueFinalModalContent,
                contentWrapperStyles,
                contentBiggerWindowHeight,
            } = useDialogWrapper(props, ctx);

            const fullOverlayClass = computed(() => {
                const defaultClass = 'dialog-wrapper__modal-overlay';
                if (unref(overlayClass)) return `${unref(overlayClass)} ${defaultClass}`;
                return defaultClass;
            });

            const fullDialogClass = computed(() => {
                const defaultClass = 'dialog-wrapper__dialog-content';
                if (unref(dialogClass)) return `${unref(dialogClass)} ${defaultClass}`;
                return defaultClass;
            });

            const handleModalClose = () => {
                if (closedByButton.value) {
                    closedByButton.value = false;
                } else {
                    handleOverlayClick();
                }
            };

            const handleOverlayClick = () => {
                if (!props.preventClose) {
                    close();
                    DataLayerService.sendPromoClick({
                        id: props.promoData.title,
                        creative: props.promoData.creative,
                        position: props.promoData.position,
                        creative_slot: 'Close_empty_area'
                    });
                }
            };

            const clickCloseBtn = (event, creative_slot) => {
                closedByButton.value = true;
                close();
                DataLayerService.sendPromoClick({
                    id: props.promoData.title,
                    creative: props.promoData.creative,
                    position: props.promoData.position,
                    creative_slot: creative_slot,
                });
            };

            return {
                open,
                close,
                onOpened,
                onClosed,
                clickCloseBtn,
                isOpened,
                refVueFinalModal,
                refVueFinalModalContent,
                contentWrapperStyles,
                contentBiggerWindowHeight,
                fullOverlayClass,
                fullDialogClass,
                handleOverlayClick,
                handleModalClose
            };
        },
    });
